var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Preguntas"}},[_c('div',[_c('PreguntasComponentVue')],1)]),_c('vs-tab',{attrs:{"label":"Exportar Preguntas"}},[_c('div',[_c('PreguntasExportarVue')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }